// Ported from [Nuxt](https://github.com/nuxt/nuxt/blob/main/packages/nuxt/src/app/composables/cookie.ts)
import { parse, serialize } from 'cookie-es'
import { destr } from 'destr'
import { ref, watch } from 'vue'

/**
 * Like useCookie but stores large values in localStorage to avoid the 4 KB cookie limit.
 * Keeps a tiny presence-marker cookie so server-side guards can still detect auth state.
 */
export const useLocalData = (key) => {
  const raw = localStorage.getItem(key)
  const data = ref(raw ? destr(raw) : null)

  watch(data, (val) => {
    if (val === null || val === undefined) {
      localStorage.removeItem(key)
      // Remove presence marker cookie
      document.cookie = serialize(`_ld_${key}`, '', { path: '/', maxAge: -1 })
    } else {
      localStorage.setItem(key, typeof val === 'string' ? val : JSON.stringify(val))
      // Set a tiny presence-marker cookie (just "1") so guards can detect auth
      document.cookie = serialize(`_ld_${key}`, '1', { path: '/', maxAge: 60 * 60 * 24 * 30 })
    }
  }, { flush: 'sync' })

  return data
}

const CookieDefaults = {
  path: '/',
  watch: true,
  decode: val => destr(decodeURIComponent(val)),
  encode: val => encodeURIComponent(typeof val === 'string' ? val : JSON.stringify(val)),
}

export const useCookie = (name, _opts) => {
  const opts = { ...CookieDefaults, ..._opts || {} }
  const cookies = parse(document.cookie, opts)
  const cookie = ref(cookies[name] ?? opts.default?.())

  watch(cookie, () => {
    document.cookie = serializeCookie(name, cookie.value, opts)
  }, { flush: 'sync' })
  
  return cookie
}
function serializeCookie(name, value, opts = {}) {
  if (value === null || value === undefined)
    return serialize(name, value, { ...opts, maxAge: -1 })
  
  return serialize(name, value, { ...opts, maxAge: 60 * 60 * 24 * 30 })
}
